import React, { useEffect } from 'react';
import { Container, Paper, Toolbar, Tabs, Tab, Box } from '@mui/material';
import { useLocation, Link, Routes, Route, Outlet, useParams, useNavigate } from 'react-router-dom';

import { userSelector, hasAnyAdminSpace } from 'helper/security';
import i18next from 'i18next';
import Products from './products';
import Product from './product';
import { ProductCreate } from './product';
import ProductBundles from './bundles/bundles';
import ProductBundle from './bundles/bundle';
import { ProductBundleCreate } from './bundles/bundle';
import Facilities from './facilities';
import Facility from './facility';
import { FacilityCreate } from './facility';
import Import from './import';
import SKU from './sku';
import { bookingModeSelector } from 'helper/filter';
import { EBookingMode } from 'types';

export default function ProductsIndex() {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingMode = bookingModeSelector();
  const user = userSelector()!;

  // Redirect to pricelists when switching from SEM mode to EPILO mode (except for seminargo and root users)
  useEffect(() => {
    if (bookingMode === EBookingMode.EPILO && !user.isSeminargo && !user.isRoot) {
      navigate('/pricelists', { replace: true });
    }
  }, [bookingMode, navigate, user.isSeminargo, user.isRoot]);

  // Only render products in SEM mode (except for seminargo and root users)
  if (bookingMode !== EBookingMode.SEM && !user.isSeminargo && !user.isRoot) {
    return null;
  }

  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Tabs value={location.pathname === '/products' ? '/products/products' : location.pathname.split('/').slice(0, 3).join('/')}>
            <Tab value="/products/products" label={i18next.t('products-tabs-header-products')} component={Link} to="/products/products" />
            <Tab value="/products/bundles" label={i18next.t('products-tabs-header-bundles')} component={Link} to="/products/bundles" />
            <Tab value="/products/facilities" label={i18next.t('products-tabs-header-facilities')} component={Link} to="/products/facilities" />
            {hasAnyAdminSpace(user) && (
              <Tab value="/products/import" label={i18next.t('products-tabs-header-import')} component={Link} to="/products/import" />
            )}
          </Tabs>

          <Box p={2}>
            <Routes>
              <Route index element={<Products />} />
              <Route path="products/_create" element={<ProductCreate />} />
              <Route path="products/:id" Component={() => <Product id={parseInt(useParams().id!)} />} />
              <Route path="products" element={<Products />} />
              <Route path="bundles/_create" element={<ProductBundleCreate />} />
              <Route path="bundles/:id" Component={() => <ProductBundle id={parseInt(useParams().id!)} />} />
              <Route path="bundles" element={<ProductBundles />} />
              <Route path="facilities/_create" element={<FacilityCreate />} />
              <Route path="facilities/:id" Component={() => <Facility id={parseInt(useParams().id!)} />} />
              <Route path="facilities" element={<Facilities />} />
              <Route path="import" element={<Import />} />
              <Route path="sku/:sku" Component={() => <SKU sku={useParams().sku!} />} />
            </Routes>

            <Outlet />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
